module.exports = __webpack_public_path__ + "static/img/6.5db69d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruselFuturo/6.jpg
// module id = xSsc
// module chunks = 5